import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type FeedbackStatus = "useful" | "not_useful" | "pending";

interface SaveFeedbackParams {
  articleId: string;
  status: FeedbackStatus;
  notes?: string;
  feedbackBy: string;
}

export function useSaveArticleFeedback() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ articleId, status, notes, feedbackBy }: SaveFeedbackParams) => {
      const { error } = await (supabase as any)
        .from("news_intelligence")
        .update({
          feedback_status: status,
          feedback_notes: notes || null,
          feedback_by: feedbackBy,
          feedback_at: new Date().toISOString(),
        })
        .eq("id", articleId);
      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["news-intelligence"] });
    },
  });
}
